import React from 'react';
import {SignInContainer} from "./sign_in_styles";
import {LightButton} from "../common_style/button";
import {LightTextInput} from "../common_style/text_input";
import {LinkLight} from "../common_style/link";
import {Span} from "../common_style/text";
import {Colors, FontStyles} from "../constants";
// assets
import logo from '../../assets/icons/logo.png';
import eu_flag from '../../assets/icons/eu_flag.png';
import {SignUpContainer} from "../sign_up/sign_up_styles";
import {Localization} from "localizations/languages";

function PasswordReset(props) {
    let textOutlineColor = props.passwordResetInvalid ? Colors.error : null;
    return <SignInContainer onSubmit={(e) => {
        e.preventDefault();
        props.onPasswordReset(e);
    }}>
        <img style={{width: '274px', marginTop: '47px', marginBottom: '55px'}} src={logo}/>
        <Span textStyle={FontStyles.titleLight}>{Localization.current.translation33}</Span>
        <div style={{height: '116px'}}/>
        <LightTextInput outlineColor={textOutlineColor} id="email" label={Localization.current.translation10}
                        name={'email'} autoComplete={'e-mail'}/>
        <div style={{height: '60px', paddingTop: '10px'}}>
            {
                props.passwordResetInvalid ? <Span textStyle={FontStyles.error}>
                    Email is invalid
                </Span> : null
            }
            {
                props.passwordResetDone ? <Span textStyle={FontStyles.body} style={{fontSize: '16px'}}>
                    {Localization.current.translation35}
                </Span> : null
            }

        </div>
        <LightButton>
            {Localization.current.translation34}
        </LightButton>
        <div style={{height: '240px'}}/>
        <div style={{display: 'flex', width: '320px', alignItems: 'center', marginBottom: '48px'}}>
            <img style={{height: '65px', marginRight: '20px'}} src={eu_flag}/>
            <Span textStyle={FontStyles.smallPrintLight}>{Localization.current.translation38}</Span>
        </div>
    </SignInContainer>
}

export default PasswordReset;
